import axios from '@/utils/request';
const prefix = 'ivm-mqtt';

export const set_invoice_settings = ({ wholesaler, asset_no, customer_code, op_locate_id }, version, invoice_settings) =>
  axios.post(`${prefix}/set-invoice-settings`, invoice_settings, {
    params: { wholesaler, asset_no, customer_code, op_locate_id, version },
  });
